import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const PageLoader: React.FC = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const onReady = () => {
      setTimeout(() => setShow(false), 1400);
    };
    if (document.readyState === 'complete') onReady();
    else window.addEventListener('load', onReady, { once: true });
    return () => window.removeEventListener('load', onReady);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="page-loader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } }}
          style={{
            position: 'fixed', inset: 0, zIndex: 10000,
            background: '#00040f',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexDirection: 'column', overflow: 'hidden',
          }}
        >
          {/* Étoiles de fond */}
          <div className="pl-stars" />

          {/* Satellite qui traverse */}
          <motion.svg
            width="80" height="50" viewBox="0 0 80 50"
            initial={{ x: '-60vw', rotate: -8 }}
            animate={{ x: '60vw', rotate: 8 }}
            transition={{ duration: 1.4, ease: [0.4, 0, 0.6, 1] }}
            style={{ position: 'absolute', top: '38%' }}
          >
            <rect x="30" y="18" width="20" height="14" fill="#d8dde5" />
            <rect x="10" y="22" width="18" height="6" fill="#1a4060" />
            <rect x="52" y="22" width="18" height="6" fill="#1a4060" />
            <circle cx="40" cy="14" r="3" fill="#5ce1e6" />
            <line x1="40" y1="17" x2="40" y2="11" stroke="#9098a8" strokeWidth="1" />
            {/* trainée */}
            <line x1="-60" y1="25" x2="10" y2="25" stroke="#5ce1e6" strokeWidth="1.5" opacity="0.5" />
          </motion.svg>

          {/* Logo JM qui assemble */}
          <div style={{ position: 'relative', width: 120, height: 120 }}>
            <motion.span
              initial={{ x: -80, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.8, duration: 0.5, ease: [0.34, 1.56, 0.64, 1] }}
              style={{
                position: 'absolute', left: 10, top: 20,
                fontFamily: 'Orbitron, monospace', fontSize: 72, fontWeight: 800,
                color: '#f0f8ff', letterSpacing: -2,
              }}
            >
              J
            </motion.span>
            <motion.span
              initial={{ x: 80, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.9, duration: 0.5, ease: [0.34, 1.56, 0.64, 1] }}
              style={{
                position: 'absolute', left: 55, top: 20,
                fontFamily: 'Orbitron, monospace', fontSize: 72, fontWeight: 800,
                color: '#5ce1e6', letterSpacing: -2,
              }}
            >
              M
            </motion.span>
            <motion.span
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 1.2, duration: 0.3 }}
              style={{
                position: 'absolute', right: 10, top: 60,
                fontFamily: 'Orbitron, monospace', fontSize: 48, fontWeight: 800,
                color: '#5ce1e6',
              }}
            >
              .
            </motion.span>
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.0, duration: 0.4 }}
            style={{
              marginTop: 24,
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: 11, letterSpacing: 3,
              color: 'rgba(240,248,255,0.5)',
              textTransform: 'uppercase',
            }}
          >
            Loading orbit...
          </motion.div>

          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.3, ease: 'easeInOut' }}
            style={{
              marginTop: 16, width: 200, height: 2,
              background: 'linear-gradient(90deg, transparent, #5ce1e6, transparent)',
              transformOrigin: 'left',
            }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PageLoader;
